import { BottomModal, BottomModalProps } from "components/common/BottomModal/BottomModal";
import { ApproveIcon } from "components/common/Icons/ApproveIcon";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { ColorPickerIcon } from "components/common/Icons/ColorPickerIcon";
import { Input } from "components/common/Input/Input";
import { ChromePicker, HuePicker } from "react-color";
import { useColorPickerBottomModal } from "./useColorPickerBottomModal";

interface ColorPickerBottomMenuProps extends Omit<BottomModalProps, "titleBar" | "children"> {
    color: string;
    setColor: (color: string) => void;
    onApprove: (color: string) => void;
    title: string;
}

export const ColorPickerBottomModal = ({
    color,
    setColor,
    isOpen,
    onClose: close,
    onApprove,
    title,
    ...props
}: ColorPickerBottomMenuProps) => {
    const { onChange, onInput } = useColorPickerBottomModal(setColor);
    return (
        <BottomModal
            isOpen={isOpen}
            onClose={close}
            titleBar={<TitleBar close={close} approve={() => onApprove(color)} title={title} />}
            containerId="mobile-color-picker-modal"
            {...props}
        >
            <div className="px-2 py-2 mx-4 my-4 border border-[#E6E7E9] dark:border-darkSurface-600 touch-none flex flex-col gap-4 rounded-md text-black dark:text-white">
                <ChromePicker
                    disableAlpha={true}
                    color={color}
                    onChange={onChange}
                    styles={{
                        default: {
                            body: {
                                display: "none",
                            },
                            picker: {
                                width: "100%",
                                height: "112px",
                                boxShadow: "",
                                borderRadius: "0.25rem",
                                overflow: "hidden",
                            },
                        },
                    }}
                />
                <HuePicker
                    styles={{
                        default: {
                            picker: {
                                borderRadius: "0.5rem",
                                overflow: "hidden",
                                width: "100%",
                            },
                        },
                    }}
                    color={color}
                    onChange={onChange}
                />
                <div className="flex items-between border border-irGray-300 dark:border-darkSurface-600 p-0.5 rounded-md">
                    <div className="w-full">
                        <Input
                            className="w-full border-none bg-irGray-200 rounded-none rounded-l-md focus:outline-0"
                            value={color.toUpperCase()}
                            placeholder="Enter a color or choose from the picker"
                            onChange={onInput}
                        />
                    </div>
                    <div className="grid place-items-center px-4">
                        <ColorPickerIcon />
                    </div>
                </div>
            </div>
        </BottomModal>
    );
};

interface TitleBarProps {
    approve: () => void;
    title: string;
    close?: () => void;
}

const TitleBar = ({ close, approve, title }: TitleBarProps) => {
    return (
        <div className="flex items-center justify-between pt-2 pb-4 px-4 text-black dark:text-white">
            <div
                className="w-6 h-6 rounded-full grid place-items-center bg-irGray-300 dark:bg-darkSurface-300"
                onClick={close}
            >
                <CloseIcon />
            </div>
            <div className="text-lg">{title}</div>
            <div onClick={approve}>
                <ApproveIcon />
            </div>
        </div>
    );
};
